import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Itrequestform = () => {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="form-wrapper">
        <style>
          {`
            .form-wrapper {
              background-color: rgb(236 115 34);
              width:70%;
             
              padding: 40px;
            
              box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
              animation: fadeIn 1s ease-out;
              position: relative;
              z-index: 10;
              border-radius: 20px;
            
            }

            .title {
              font-size: 28px;
              text-align: center;
              color: #333;
              margin-bottom: 10px;
            }

            .subtitle {
              text-align: center;
              color: #666;
              font-size: 16px;
              margin-bottom: 30px;
            }

            .contact-form {
              width: 100%;
            }

            .form-row {
              display: flex;
              flex-wrap: wrap;
              gap: 20px;
              margin-bottom: 20px;
            }

            .form-column {
              flex: 1;
              min-width: 250px;
            }

            .form-label {
              display: block;
              color: #333;
              font-size: 14px;
              margin-bottom: 5px;
            }

            .form-input, .form-textarea {
              width: 100%;
              padding: 12px;
              border-radius: 8px;
              border: 1px solid #ddd;
              transition: border-color 0.3s, transform 0.3s;
            }

            .form-input:focus, .form-textarea:focus {
              border-color: #6f6df4;
              outline: none;
              transform: scale(1.02);
            }

            .form-textarea {
              resize: none;
            }

            .submit-button {
              display: block;
            
              padding: 12px;
              // background: linear-gradient(135deg, #6f6df4, #4c46f5);
              background: #fff;
              color: #000;
              border: none;
              border-radius: 8px;
              font-size: 16px;
              cursor: pointer;
              transition: background 0.3s, transform 0.3s;
            }

            .submit-button:hover {
              background: linear-gradient(135deg, #edcf39, #edcf39);
              transform: scale(1.05);
            }

            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(-20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            @media (max-width: 768px) {
              .form-wrapper {
                padding: 30px;
                margin-top: 100px;
              }

              .title {
                font-size: 24px;
              }

              .subtitle {
                font-size: 14px;
              }

              .form-row {
                flex-direction: column;
              }
            }

            @media (max-width: 540px) {
              .form-wrapper {
                padding: 20px;
                margin-top: 160px !important;
                margin-bottom: 27px ;
              }

              .title {
                font-size: 20px;
              }

              .subtitle {
                font-size: 12px;
              }

              .form-row {
                flex-direction: column;
                gap: 15px;
              }

              .form-column {
                min-width: 100%;
              }

              .form-label {
                font-size: 12px;
              }

              .form-input, .form-textarea {
                padding: 10px;
              }

              .submit-button {
                padding: 10px;
                font-size: 14px;
              }
            }
          `}
        </style>
        <div className="row">
          {/* Left side content */}
          <div className="col-md-4 mt-5">
            <h3 style={{ color: '#fff', marginTop: '45px', marginBottom: '5px', fontSize:'30px' }}>Request for Services</h3>
            <div
              style={{
                // width: '280px', 
                height: '3px',  // Thickness of the underline
                backgroundColor: '#000', // Color of the underline
                marginTop: '5px', // Spacing between text and underline
                marginLeft: '12px'
              }}
              className="form-wrapper-hr"
            ></div>
          </div>



          {/* Right side contact form */}
          <div className="col-md-8">
            {/* <h1 className="title">Contact Us</h1>
            <p className="subtitle">
              Got questions or comments? Use the form below to get in touch.
            </p> */}
            <form className="contact-form">
              <div className="form-row">
                <div className="form-column">
                  {/* <label htmlFor="name" className="form-label">
                    Name
                  </label> */}
                  <input
                    type="text"
                    id="name"
                    placeholder="First Name"
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-column">
                  {/* <label htmlFor="email" className="form-label">
                    Email
                  </label> */}
                  <input
                    type="email"
                    id="email"
                    placeholder="Last Name"
                    className="form-input"
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  {/* <label htmlFor="contact" className="form-label">
                    Contact
                  </label> */}
                  <input
                    type="tel"
                    id="contact"
                    placeholder="Email"
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-column">
                  {/* <label htmlFor="subject" className="form-label">
                    Subject
                  </label> */}
                  <input
                    type="text"
                    id="subject"
                    placeholder="Company Name"
                    className="form-input"
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  {/* <label htmlFor="contact" className="form-label">
                    Contact
                  </label> */}
                  <input
                    type="tel"
                    id="contact"
                    placeholder="Job Title"
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-column">
                  {/* <label htmlFor="subject" className="form-label">
                    Subject
                  </label> */}
                  <input
                    type="text"
                    id="subject"
                    placeholder="Phone"
                    className="form-input"
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  {/* <label htmlFor="issue" className="form-label">
                    Describe your issue
                  </label> */}
                  <textarea
                    id="issue"
                    placeholder="Describe your issue"
                    rows="2"
                    className="form-textarea"
                    required
                  ></textarea>
                </div>
              </div>
              <div className="d-flex justify-content-center mt-3">
                <button type="submit" className="submit-button">
                  Submit
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Itrequestform;
